// Token storage in localStorage. For a closed friend-group app with no
// third-party scripts beyond Google Identity Services, this is an acceptable
// trade-off — see PLAN.md §5.

const KEY = 'mondy_token';

export function getToken(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string): void {
  try {
    window.localStorage.setItem(KEY, token);
  } catch {
    // localStorage can be disabled in privacy modes; fail silently.
  }
}

export function clearToken(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
}
